export const getewaysConstants = {
  INIT: 'FETCH_GATEWAYS_INIT',
  SUCCESS: 'FETCH_GATEWAYS_SUCCESS',
  UPDATE: 'FETCH_GATEWAYS_UPDATE',
  FAILURE: 'FETCH_GATEWAYS_FAILURE',
  CLEAR: 'FETCH_GATEWAYS_CLEAR',
}
